// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"styles_iconButton__2fehF","menuPaper":"styles_menuPaper__2i9ld","menuList":"styles_menuList__1PMC0","studentLink":"styles_studentLink__V4oLi"};